import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { AutoDraft, AutoDraftNotifications } from './auto-draft.model';


export const loadAutoDrafts = createSourcedAction('Load auto-drafts');

export const setAutoDrafts = createSourcedAction('Set auto-drafts', props<{ autoDraftsData: AutoDraft[] }>());

export const saveRegularAutoDraft = createSourcedAction('Save regular auto draft', props<{
    operationId: string
    accountNumber: string
    month: number
    day: number
    paymentMethodId: string
    notifications: AutoDraftNotifications
}>());

export const saveInstallmentsAutoDraft = createSourcedAction('Save installments auto draft', props<{
    operationId: string
    accountNumber: string
    days: number[]
    paymentMethodId: string
    notifications: AutoDraftNotifications
}>());

export const autoDraftSaved = createSourcedAction('Auto-draft saved', props<{ operationId: string }>());
export const autoDraftSaveFailed = createSourcedAction('Auto-draft save failed', props<{ operationId: string }>());

export const setAutoDraft = createSourcedAction('Update auto-draft', props<{ autoDraftData: AutoDraft }>());

export const disableAutoDraft = createSourcedAction('Disable auto-draft', props<{ accountNumber: string }>());

export const autoDraftDisabled = createSourcedAction('Auto-draft disabled', props<{ accountNumber: string }>());
export const autoDraftDisableFailed = createSourcedAction('Auto-draft disable failed', props<{ accountNumber: string }>());

export const removeAutoDraft = createSourcedAction('Remove auto-draft', props<{ accountNumber: string }>());

export const flushAutoDraftState = createSourcedAction('Flush auto-draft state');
